// src/components/HeadMeta.jsx
import React from 'react';
import { Helmet } from 'react-helmet';

const toPublicPath = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/+$/, '');

  return publicUrl ? `${publicUrl}${normalizedPath}` : normalizedPath;
};

const HeadMeta = () => {
  const brand = process.env.REACT_APP_MODAL;

  const metaData = {
    eternals: {
      title: '恆美學 後台系統',
      favicon: '/eternal-logo.ico',
      appleIcon: '/eternal-apple-touch-icon.png',
      manifest: '/manifest-eternal.json',
      description:
        '恆美學一站式醫美管理系統，協助診所提升營運效率，整合預約、病歷、行銷、庫存與顧客關係管理。',
    },
    obsicloud: {
      title: '黑曜雲 後台系統',
      favicon: '/obsicloud-logo.ico',
      appleIcon: '/obsicloud-apple-touch-icon.png',
      manifest: '/manifest-obsicloud.json',
      description:
        '黑曜雲智能醫美雲平台，專為診所打造的營運數位化解決方案，提升顧客體驗與管理效率。',
    },
  };

  const { title, favicon, appleIcon, manifest, description } =
    metaData[brand] || {
      title: 'APAM 後台系統',
      favicon: '/apam-logo.ico',
      appleIcon: '/apam-logo-192.png',
      manifest: '/manifest.json',
      description: 'APAM 艾恩科技後台管理系統。',
    };

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="icon" href={toPublicPath(favicon)} />
      <link rel="apple-touch-icon" href={toPublicPath(appleIcon)} />
      <link rel="manifest" href={toPublicPath(manifest)} />
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default HeadMeta;
